module.exports = __webpack_public_path__ + "img/no-data.2e2de5b4.png";